/**
 * Stock del producto en el carrito (FRONT-AUDITORIA-VISTAS-T1 hallazgo 8; SI de Ares #30193).
 *
 * Regla del Desktop (FrmVentaV15): un producto de receta (inventario_directo = 0) no lleva stock propio -- su stock
 * vive en los insumos -- asi que su inventario llega en 0 y decir "Sin stock" es falso. Medido 19-oct en
 * nexo_sync.sync_productos: en un negocio, los 171 productos de receta estaban en 0; de los 114 directos, 5.
 *
 *   directo = 1 (o sin la clave, como antes) -> 'con' (Stock: n) o 'sin' (Sin stock)
 *   directo = 0                              -> 'no_aplica' (no se dice nada)
 *
 * @module application/carrito/stockDelProducto
 */

/** true si el producto lleva stock propio. Sin la clave se asume que si (comportamiento anterior). */
export function llevaStock(d = {}) {
  const v = d.inventario_directo ?? d.InventarioDirecto ?? d.inventarioDirecto;
  if (v === undefined || v === null || v === '') return true;
  return v === true || String(v) === '1' || String(v).toLowerCase() === 'true';
}

/** Estado del chip: 'con' | 'sin' | 'no_aplica'. */
export function estadoDeStock(p) {
  if (p.llevaStock === false) return 'no_aplica';
  return p.stock > 0 ? 'con' : 'sin';
}
